import { useSelectionStore } from '../selectionStore';

/**
 * 特定のデータセットの選択状態を簡単に管理するためのフック
 * 既存のDataTableSelectionContextと互換性のあるインターフェースを提供
 */
export const useDatasetSelection = (datasetId: string | undefined) => {
  // 選択状態を取得（shallow比較で最適化）
  const selection = useSelectionStore(
    state => datasetId ? state.getSelection(datasetId) : null
  );
  
  // アクションを取得（これらは変更されないのでshallow比較不要）
  const selectColumns = useSelectionStore(state => state.selectColumns);
  const selectRows = useSelectionStore(state => state.selectRows);
  const resetSelection = useSelectionStore(state => state.resetSelection);
  
  // datasetIdがない場合のデフォルト値
  if (!datasetId || !selection) {
    return {
      selectedColumns: [],
      selectedRows: [],
      selectColumns: () => {},
      selectRows: () => {},
      resetSelection: () => {}
    };
  }
  
  // 既存のコードと互換性のあるインターフェースを返す
  return {
    selectedColumns: selection?.selectedColumns || [],
    selectedRows: selection?.selectedRows || [],
    selectColumns: (columns: string[]) => selectColumns(datasetId, columns),
    selectRows: (rows: number[]) => selectRows(datasetId, rows),
    resetSelection: () => resetSelection(datasetId)
  };
};

/**
 * 全体の選択状態を管理するためのフック
 * DataTableSelectionContextのuseDataTableSelectionと互換
 */
export const useDataTableSelection = () => {
  const selections = useSelectionStore(state => state.selections);
  const getSelection = useSelectionStore(state => state.getSelection);
  const updateSelection = useSelectionStore(state => state.updateSelection);
  const selectColumns = useSelectionStore(state => state.selectColumns);
  const selectRows = useSelectionStore(state => state.selectRows);
  const resetSelection = useSelectionStore(state => state.resetSelection);
  const removeSelection = useSelectionStore(state => state.removeSelection);
  
  return {
    selections,
    getSelection,
    updateSelection,
    selectColumns,
    selectRows,
    resetSelection,
    removeSelection
  };
};